import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const DropZoneArea = styled.div`
	display: flex;
	background-color: white;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	padding: 32px;
	border-width: 0 1px 1px 1px;
	border-color: ${colors.grey4};
	border-style: dashed;
	border-radius: 0 0 3px 3px;
`;

export const DropZoneText = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
`;

export const LeftAlignBox = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
`;

export const DescriptionText = styled.div`
	width: 150px;
	color: ${colors.grey5};
	font-size: 13px;
	line-height: 19px;
	text-align: center;
	letter-spacing: 0.3px;

	span {
		font-weight: 700;
		font-size: 16px;
		color: ${colors.grey7};
	}
`;

export const LeftAlignFlex = styled.div`
	align-self: flex-start;
`;

export const UploadProgressCounter = styled.span`
	font-size: 16px;
	letter-spacing: 0.3px;
	margin-left: auto;
	color: ${colors.grey7};
	flex-shrink: 0;
	margin-left: 24px;
	display: flex;
	align-items: flex-end;
`;

const pulsate = keyframes`
	0% {
	  width: 5%;
	  opacity: 0.5;
	}
	100% {
	  width: 100%;
	  opacity: 0;
	}
`;

const UploadProgressInner = styled.div`
	width: ${({ value }) => value};
	border-radius: 2px;
	height: 24px;
	background-color: ${colors.blue};
	transition: width 0.2s;
`;

const FlashBar = styled.div`
	border-radius: 2px;
	height: 24px;
	background-color: white;
	transition: width 0.2s;
	animation: ${pulsate} 1.7s ease-out;
	animation-iteration-count: infinite;
`;

export const UploadProgressBar = styled(({ value, ...props }) => (
	<div {...props}>
		<UploadProgressInner value={`${value}%`}>
			<FlashBar />
		</UploadProgressInner>
	</div>
))`
	background: white;
	width: 100%;
	margin-top: 8px;
`;

export const DropWrapper = styled.div`
	outline: none;
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export const ErrorTextWrapper = styled.div`
	border-bottom: 1px solid ${colors.grey2};
	padding-bottom: 8px;
	width: 100%;
	margin-bottom: 15px;
`;

export const UploadTitleText = styled.div`
	font-size: 19px;
	color: ${colors.grey7};
	font-weight: 500;
	margin-bottom: 25px;
	align-self: flex-start;
`;

export const UploadErrorText = styled(UploadTitleText)`
	margin-bottom: 14px;
`;

export const TitleMessage = styled.div`
	color: ${colors.grey8};
	padding-bottom: 32px;
	font-size: 19px;
	line-height: 27px;
	text-align: center;
`;

export const ActionsWrapper = styled.div`
	display: flex;
	justify-content: center;
`;

export const StatusText = styled.div`
	font-size: 16px;
	color: ${colors.grey7};
	letter-spacing: 0.3px;
	flex-grow: 1;
`;

export const IconWrapper = styled.div`
	margin-bottom: 32px;
`;

export const ButtonWrapper = styled.div`
	padding-top: 20px;
`;

export const ProgressText = styled.div`
	display: flex;
	width: 100%;
`;

export const Notes = styled.div`
	ul {
		padding: 10px 10px 10px 40px;
	}

	li {
		list-style: initial;
	}
`;